import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Filters } from '../models/filters.model';

@Injectable({
  providedIn: 'root'
})
export class FilterStateService {
  private defaultFilters: Filters = {
    openTo: [],
    offerLookingFor: [],
    action: [],
    country: [],
    language: [],
    expirationDate: '',
    affiliation: [],
    fieldOfScience: [],
    focusAreas: [],
  };

  private filtersSubject = new BehaviorSubject<Filters>(this.defaultFilters);
  filters$ = this.filtersSubject.asObservable();

  setOpenToFilter(openTo: string[]) {
    const currentFilters = this.filtersSubject.value;
    this.filtersSubject.next({
      ...currentFilters,
      openTo: openTo
    });
  }

  setFocusAreasFilter(focusAreas: string[]) {
    const currentFilters = this.filtersSubject.value;
    this.filtersSubject.next({
      ...currentFilters,
      focusAreas: focusAreas
    });
  }

  setOfferLookingForFilter(offerLookingFor: string[]) {
    const currentFilters = this.filtersSubject.value;
    this.filtersSubject.next({
      ...currentFilters,
      offerLookingFor
    });
  }

  setActionFilter(action: string[]) {
    const currentFilters = this.filtersSubject.value;
    this.filtersSubject.next({
      ...currentFilters,
      action
    });
  }

  setCountryFilter(country: string[]) {
    const currentFilters = this.filtersSubject.value;
    this.filtersSubject.next({
      ...currentFilters,
      country
    });
  }

  setLanguageFilter(language: string[]) {
    const currentFilters = this.filtersSubject.value;
    this.filtersSubject.next({
      ...currentFilters,
      language
    });
  }

  setAffiliationFilter(affiliation: string[]) {
    const currentFilters = this.filtersSubject.value;
    this.filtersSubject.next({
      ...currentFilters,
      affiliation
    });
  }

  setFieldOfScienceFilter(fieldOfScience: string[]) {
    const currentFilters = this.filtersSubject.value;
    this.filtersSubject.next({
      ...currentFilters,
      fieldOfScience
    });
  }

  setExpirationDateFilter(expirationDate: string) {
    const currentFilters = this.filtersSubject.value;
    this.filtersSubject.next({
      ...currentFilters,
      expirationDate
    });
  }

  clearFilters() {
    this.filtersSubject.next(this.defaultFilters);
  }

  getCurrentFilters(): Filters {
    return this.filtersSubject.value;
  }
}
